import { Box, Button, Grid } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BucketDefinitionSettings from "../components/Settings/BucketDefinitionSettings";
import { ModalProps, setProps } from "../features/Slices/modalSlice";
import { setUseModalSpace } from "../features/Slices/modalSpaceSlice";
import { CurrentUser } from "../types";

const BucketDefinitions = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const modal: ModalProps = useSelector((state: any) => state.modal.value);
	const user: CurrentUser = useSelector((state: any) => state.userData.value);

	useEffect(() => {
		dispatch(setProps({ ...modal, IsOpen: false }));
		dispatch(setUseModalSpace(false));
		return () => { dispatch(setUseModalSpace(true)); };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch]);

	useEffect(() => {
		if (user && (!user.isHoH || !user.isActive)) {
			navigate("/Settings/Profile", { replace: true });
		}
	}, [navigate, user]);

	if (!user?.isHoH || !user?.isActive) {
		return <></>;
	}

	return (
		<div className="container-fluid">
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
						<Button variant="outlined" color="secondary" onClick={() => navigate("/Settings/Family")}>
							Back to Family Settings
						</Button>
					</Box>
				</Grid>
				<BucketDefinitionSettings />
			</Grid>
		</div>
	);
};

export default BucketDefinitions;